import type {PanelPlacement} from '../features/ui/PanelPlacement'

export const defaultViewMode = 'desktop'
export const defaultOpenedPanels: PanelPlacement[] = ['left', 'right']
export const defaultBottomPanelHeight = 380
